import React, { useState, useEffect } from "react";
import { Box, Modal, Typography, useTheme, CircularProgress } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import { getEntregasByPedido } from "../../services/pedidoVenta.services";

const statusLabel = (status) => {
  const map = { PENDIENTE: "Pendiente", EN_CARGA: "En carga", COMPLETADO: "Completado" };
  return map[status] ?? status;
};

const columns = [
  { field: "nro_orden", headerName: "Orden", width: 90 },
  { field: "fecha_carga", headerName: "Fecha", width: 130,
    valueFormatter: ({ value }) => value ? new Date(value).toLocaleDateString() : "-" },
  { field: "chapa", headerName: "Vehículo", width: 110 },
  { field: "cantidad_asignada", headerName: "Asignado", width: 100, type: "number" },
  { field: "cantidad_cargada", headerName: "Cargado", width: 100, type: "number" },
  { field: "status", headerName: "Estado", width: 120,
    valueFormatter: ({ value }) => statusLabel(value) },
];

const ModalHistorialEntregas = ({ open, onClose, idPedidoVenta }) => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  useEffect(() => {
    if (open && idPedidoVenta) {
      setLoading(true);
      getEntregasByPedido(idPedidoVenta)
        .then((data) => setRows(Array.isArray(data) ? data : []))
        .catch(() => setRows([]))
        .finally(() => setLoading(false));
    }
  }, [open, idPedidoVenta]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <Box sx={{
        backgroundColor: colors.primary[600],
        padding: "20px",
        minWidth: "600px",
        maxWidth: "90vw",
        maxHeight: "80vh",
        display: "flex",
        flexDirection: "column",
        gap: "12px",
      }}>
        <Typography variant="h4" fontWeight="bold">Historial de entregas</Typography>
        <Typography variant="h6" sx={{ color: colors.grey[300] }}>
          Pedido #{idPedidoVenta}
        </Typography>
        {loading ? (
          <Box display="flex" justifyContent="center" p={4}>
            <CircularProgress color="secondary" />
          </Box>
        ) : (
          <DataGrid
            rows={rows}
            columns={columns}
            getRowId={(row) => row.id}
            autoHeight
            disableSelectionOnClick
            sx={{
              "& .MuiDataGrid-root": { border: "none" },
              "& .MuiDataGrid-cell": { borderBottom: "none" },
              "& .MuiDataGrid-columnHeaders": { backgroundColor: colors.blueAccent[700], borderBottom: "none" },
              "& .MuiDataGrid-virtualScroller": { backgroundColor: colors.primary[400] },
              "& .MuiDataGrid-footerContainer": { borderTop: "none", backgroundColor: colors.blueAccent[700] },
            }}
          />
        )}
      </Box>
    </Modal>
  );
};

export default ModalHistorialEntregas;
